export enum GodAbility {
    NONE = "NONE",
    MOVE_INTO = "MOVE_INTO",
    EXTRA_MOVE_NOT_BACK = "EXTRA_MOVE_NOT_BACK",
    OPPONENT_NOT_UP = "OPPONENT_NOT_UP",
    EXTRA_BUILD_NOT_SAME = "EXTRA_BUILD_NOT_SAME",
    EXTRA_BUILD_ONLY_SAME = "EXTRA_BUILD_ONLY_SAME",
    MOVE_ANY_TIME = "MOVE_ANY_TIME",
}